<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="8" lg="6" xl="4" align="center" justify="center">
        <v-card max-width="350" class="pa-md-2">
            <v-card-text class="font-weight-bold title text-center">쿠폰을 등록하세요</v-card-text>
            <v-text-field
                v-model="couponId"
                :value="couponId"
                :rules="couponRule"
                :success="couponSuccess"
                label="'-' 를 포함 14자리를 입력하세요"
                prepend-icon="mdi-card-bulleted"
            ></v-text-field>

            <v-btn
                class="mt-5"
                color="primary"
                @click="clickUseCoupon"
            >
              등록하기
            </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { api } from '../../mixins/api';

export default {
  name: "UseCoupon",
  data() {
    return {
      couponId: "",
      couponRule: [
        v => !(v === "") || "'-' 를 포함 14자리를 입력하세요",
        v => this.validCouponId(v) || "잘뭇된 쿠폰 번호입니다."
      ]
    }
  },
  computed: {
    couponSuccess() {
      return this.validCouponId(this.couponId);
    },
  },
  methods: {
    validCouponId(v) {
      return /^(\w){4}-(\w){4}-(\w){4}$/.test(
          v
      );
    },
    async clickUseCoupon() {
      if (this.validCouponId(this.couponId)) {
        let response = await api.methods.useCoupon(this.couponId);
        if (response.statusCode === 200) {
          if (response.result.isSucceed) {
            alert('쿠폰이 등록되었습니다.');
            this.$router.push('/');
          } else {
            alert(response.result.message);
          }
        } else {
          alert(response.result);
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
